import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { Language } from '../../../../../shared/enum/language';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { Subject } from 'rxjs';
import { IConfirmationDialogPayload } from '../../../../../shared/ui/component/confirmation-dialog/confirmation-dialog-payload.interface';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'admin-customer-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminCustomerListComponent extends AbstractListComponent implements OnInit {

  phrase: string;
  modalRef: BsModalRef;
  languages: any = Language;
  status: string = 'active';
  deactivateCustomerSubject: Subject<IConfirmationDialogPayload> = new Subject();
  activateCustomerSubject: Subject<IConfirmationDialogPayload> = new Subject();
  searchChanged: Subject<string> = new Subject<string>();

  getResourceUrl(): string {
    return '/customer';
  }

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              modalService: BsModalService,
              urlBuilder: AdminUrlBuilder,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Accounts',
      url: '/admin/customer'
    });

    this.parameters.conditions.status = 'active';
    this.parameters.conditions.plan = [ 'pro', 'premium', 'basic', 'trial' ];
    this.parameters.conditions.search = '';
    this.parameters.orderBy = 'createDate';
    this.parameters.orderDir = 'desc';
    super.ngOnInit();

    this.searchChanged.pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
      .subscribe(model => {
        this.parameters.offset = 0;
        this.load();
      });
  }

  filterByName(v: string) {
    this.searchChanged.next(v);
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  deactivate(id: number) {
    this.httpClient.post(this.urlBuilder.buildUrl(`/customer/${id}/deactivate`), {})
      .subscribe(
        (response: any) => {
          this.deactivateCustomerSubject.next(<IConfirmationDialogPayload>{
            result: true,
            message: 'Deactivated'
          });

          this.load();
        },
        (error: any) => {
          this.deactivateCustomerSubject.next(<IConfirmationDialogPayload>{
            result: false,
            message: 'Unable to deactivate account'
          });
        }
      );
  }

  activate(id: number) {
    this.httpClient.post(this.urlBuilder.buildUrl(`/customer/${id}/activate`), {})
      .subscribe(
        (response: any) => {
          this.activateCustomerSubject.next(<IConfirmationDialogPayload>{
            result: true,
            message: 'Activated'
          });

          this.load();
        },
        (error: any) => {
          this.activateCustomerSubject.next(<IConfirmationDialogPayload>{
            result: false,
            message: 'Unable to activate account'
          });
        }
      );
  }

  changePlan(plan: string) {
    if (this.parameters.conditions.plan.indexOf(plan) > -1) {
      this.parameters.conditions.plan = this.parameters.conditions.plan.filter(s => s !== plan);
    } else {
      this.parameters.conditions.plan.push(plan);
    }
    this.parameters.offset = 0;
    this.load();
  }

  changeStatus() {
    this.parameters.conditions.status = this.status;
    this.parameters.offset = 0;
    this.load();
  }
}
